import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client';
import { useAuth } from '@features/auth/hooks/useAuth';

export type ERPProfileNavigation = {
  chapters: Record<string, boolean>;
  sub_chapters: Record<string, boolean>;
};

/** An errored refresh must fall back to RBAC even when React Query retains stale data. */
export function erpProfileNavigationForMenu(
  data: ERPProfileNavigation | undefined,
  isError: boolean,
): ERPProfileNavigation | undefined {
  return isError ? undefined : data;
}

async function fetchERPProfileNavigation(): Promise<ERPProfileNavigation> {
  const { data } = await apiClient.get<ERPProfileNavigation>('/navigation/erp-profile');
  return data;
}

export function useERPProfileNavigation() {
  const { user } = useAuth();
  const cacheUserID = user?.id ?? 0;

  return useQuery({
    // The id isolates browser cache only. Authority is the authenticated request;
    // no identity/profile selector is sent to the endpoint.
    queryKey: ['navigation', cacheUserID, 'erp-profile'],
    queryFn: fetchERPProfileNavigation,
    enabled: cacheUserID > 0,
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}
